module.exports = __webpack_public_path__ + "media/images/cancel-f1294bc2.svg";